import React from 'react';
import { Select, InputNumber, Text, IconButton, SelectSizes, InputSizes, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import { PRODUCT_TYPE_OPTIONS } from '../../../configuration.constants';
import RulesPanel from '../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../common/emptyState/EmptyState';
import styles from '../styles/feeStructureForm.module.scss';

function ProductTypesPanel({ rules = [], onAdd, onRemove, onUpdate }) {
    return (
        <RulesPanel
            onAdd={onAdd}
            addLabel="Add a product type row"
            emptyState={
                <EmptyState
                    title="No product type rules yet"
                    description="Add a row to set a custom advance fee for a product type."
                />
            }
        >
            {rules.map((rule) => (
                <div key={rule.id} className={styles.ruleRow}>
                    <Text as="span" size="s" className={styles.ruleLabel}>if the product is</Text>
                    <Select
                        size={SelectSizes.SMALL}
                        value={rule.productType}
                        options={PRODUCT_TYPE_OPTIONS}
                        onChange={(value) => onUpdate(rule.id, 'productType', value)}
                        className={`${styles.select} ${styles.selectMd}`}
                    />
                    <Text as="span" size="s" className={styles.ruleLabel}>the advance fee is</Text>
                    <InputNumber
                        size={InputSizes.SMALL}
                        prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>}
                        value={rule.fee}
                        onChange={(value) => onUpdate(rule.id, 'fee', value)}
                        min={0}
                        max={999.99}
                        step={0.01}
                        precision={2}
                        controls={false}
                        className={`${styles.inlineNumberInput} ${styles.amountField}`}
                    />
                    <IconButton
                        type="button"
                        icon={<DeleteOutlined />}
                        aria-label="Remove row"
                        onClick={() => onRemove(rule.id)}
                    />
                </div>
            ))}
        </RulesPanel>
    );
}

export default ProductTypesPanel;
